export const environment = {
  apiBaseUrl: '',
  appInsightsId: '',
  envName: '',
  clientId: '',
  production: false,
};
